module.exports = __webpack_public_path__ + "img/149ne.56974218.svg";